var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndexUniversalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 71.7736,
    height: 67,
    rx: 17.5738,
    fill: "#F7F6F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5074 26.1826L27.5559 26.1826C28.243 26.2079 28.7898 26.7692 28.7898 27.456L28.7898 42.3779C28.7898 43.08 28.2169 43.6521 27.5074 43.6521C26.7978 43.6521 26.2249 43.08 26.2249 42.3779L26.2249 27.4569C26.2249 26.754 26.7977 26.1826 27.5074 26.1826Z",
    fill: "url(#paint0_linear_7153_14237)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0894 26.1826L45.1379 26.1826C45.825 26.2079 46.3719 26.7692 46.3719 27.456L46.3719 42.3779C46.3719 43.08 45.799 43.6521 45.0894 43.6521C44.3799 43.6521 43.8069 43.08 43.8069 42.3779L43.8069 27.4569C43.8069 26.754 44.3797 26.1826 45.0894 26.1826Z",
    fill: "url(#paint1_linear_7153_14237)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.195 25.011L33.2483 25.011C34.0038 25.0423 34.6531 25.7364 34.6531 26.65L34.6531 45.0389C34.6531 45.9729 33.973 46.679 33.195 46.679C32.4171 46.679 31.7369 45.973 31.7369 45.0389L31.737 26.6511C31.737 25.7161 32.417 25.011 33.195 25.011Z",
    fill: "url(#paint2_linear_7153_14237)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0544 20.3228L39.1063 20.3228C39.8387 20.357 40.5125 21.1128 40.5125 22.1658L40.5125 42.4905C40.5125 43.5672 39.8065 44.3348 39.0544 44.3348C38.3023 44.3348 37.5963 43.5672 37.5963 42.4905L37.5963 22.1671C37.5963 21.0892 38.3022 20.3228 39.0544 20.3228Z",
    fill: "url(#paint3_linear_7153_14237)",
    stroke: "#187C85",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.582 37.6025L48.1953 37.6025",
    stroke: "#187C85",
    strokeWidth: 1.17206,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7153_14237",
    x1: 34.5334,
    y1: 21.7689,
    x2: 28.7542,
    y2: 42.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7153_14237",
    x1: 52.1154,
    y1: 21.7689,
    x2: 46.3363,
    y2: 42.2985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7153_14237",
    x1: 41.0008,
    y1: 19.6415,
    x2: 33.2322,
    y2: 44.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7153_14237",
    x1: 46.8602,
    y1: 14.4197,
    x2: 37.5533,
    y2: 41.3862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#53BCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexUniversalIcon);
export default __webpack_public_path__ + "static/media/index-universal-icon.2ec33cef42dbe1f0ed7e1f1e3c21da5e.svg";
export { ForwardRef as ReactComponent };